import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrarAlmOriDes'
})
export class FiltrarAlmOriDesPipe implements PipeTransform {

  transform(array: any[], almacen: number, propiedad: string, proveedor?:string): any[]{

    if (!array || !array.length) {
      return array;
    }
    // Verificar si se seleccionó "--Todos--" en los selectores
    if(almacen==-1 && (!proveedor || proveedor=="-1")){
      return array;
    }
    else if( almacen != -1  && (!proveedor || proveedor=="-1")){
      return array.filter(registro => registro[propiedad] == almacen);
    }
    else if( almacen != -1  && (proveedor && proveedor!="-1")){
      return array.filter(registro => registro[propiedad] == almacen && registro.strProveedor==proveedor);
    }
    else if( almacen == -1  && (proveedor && proveedor!="-1")){
      return array.filter(registro =>  registro.strProveedor==proveedor);
    }
    return [];
  }
}
